import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import renderIf from '../../../../pkgs/render_if';
import MultiSelect from "@khanacademy/react-multi-select";

import {
    Button,
} from 'react-bootstrap';


export default class XeditableReactMultiSelect extends React.Component {

    constructor(props){
      super(props);
      this.state = {
        inputValue:[],
        options:[],
        options_loading: true,
        selected: [],
        step: 1,
        content: [],
      };
    }

    componentDidMount = () => {
        // console.log('initial data for ' + this.props.id)
        // console.log(JSON.parse(this.props.data_initial))
        let selected = []
        if (this.props.data_initial) {
            let data_initial= JSON.parse(this.props.data_initial);
            for (var key in data_initial) {
                if (selected.includes(data_initial[key]['id']) == false ) {
                    selected.push(data_initial[key]['id'])
                }
            }
        }
        // console.log('Selected');
        // console.log(selected);
        this.setState({selected})
        this.buildStepOneContent();
        this.loadAwesompleteAJAXJSONResponse();
    }

    buildStepOneContent = () => {
        let content = [];
        let labels = [];
       
        if (this.props.data_initial == '[]') {
            content.push(
                <span style={{marginRight:'5px'}} className='editable-click' >
                    None
                </span>
            )
        } else {
            let data_initial = JSON.parse(this.props.data_initial);
            for (var key in data_initial) {
                if (labels.includes(data_initial[key]['label']) == false) {
                    labels.push(data_initial[key]['label'])
                    content.push(
                        <span style={{marginRight:'5px'}} className='editable-click' >
                            {data_initial[key]['label']}
                        </span>
                    )
                }
            }
        }
        // console.log('labels');
        // console.log(labels);
        this.setState({content})
    }

    loadAwesompleteAJAXJSONResponse = () => {
      let app_label = this.props.app_label;
      let field = this.props.field;
      $.ajax({
          url: '/api/awesomplete/' + app_label + '/' + field + '/',
          dataType: 'json',
          cache: false,
          headers: {'Authorization': 'Token ' + localStorage.token},
          success: (data) => {
              this.setState({options:data})
          }
      });
    }

    getCookie = (c_name) => {
        if(document.cookie.length > 0) {
            let c_start = document.cookie.indexOf(c_name + "=");
            if(c_start != -1) {
                c_start = c_start + c_name.length + 1;
                let c_end = document.cookie.indexOf(";", c_start);
                if(c_end == -1) c_end = document.cookie.length;
                return unescape(document.cookie.substring(c_start,c_end));
            }
        } else {
            return "";
        }
    }

    onReplace = () => {
        let instance = {}
        instance[this.props.field] = this.state.selected; 
        // console.log('Instance')
        // console.log(instance)
        $.ajax({
            url: '/api/xeditable/patch/' + this.props.app_label + '/' + this.props.model_name + '/' + this.props.id + '/',
            dataType: 'json',
            headers: {"X-CSRFToken": this.getCookie('csrftoken')},
            method: 'PUT',
            data: instance,
        })
    }

    render() {
        const {selected} = this.state;
        return (
            <div>
                {renderIf(this.state.step == 1)(
                    <div onClick={() => this.setState({step:2})}>
                        {this.state.content}
                    </div>
                )}
                {renderIf(this.state.step == 2)(
                    <div style={{fontSize:'18px'}}>
                        <MultiSelect
                            options={this.state.options}
                            selected={selected}
                            onSelectedChanged={(selected) => this.setState({selected})}
                        />
                        <Button bsStyle='primary' bsSize='sm' onClick={this.onReplace}>
                            <i className='fa fa-check' />
                        </Button> 
                        <Button bsStyle='default' bsSize='sm' onClick={() => this.setState({step:1})} style={{marginLeft: '5px'}}>
                            <i className='fa fa-remove' />
                        </Button>
                    </div>
                )}
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/helpers/field/xeditable/xeditable_react_multi_select.js